import Post from '../api'
/********************************************* 全局支付配置 *******************************************/
/****start****/
//获取所有支付平台
export const GetAllPayPlatform = (params: any): any => {
    return Post('GetAllPayPlatform', params)
}

//保存支付平台
export const SavePayPlatform = (params: any): any => {
    return Post('SavePayPlatform', params)
}

//获取支付平台列表
export const GetPayPlatformList = (params: any): any => {
    return Post('GetPayPlatformList', params)
}

//删除支付平台
export const DelPayPlatform = (params: any): any => {
    return Post('DelPayPlatform', params)
}

//保存支付平台配置
export const SavePayPlatformConfig = (params: any): any => {
    return Post('SavePayPlatformConfig', params)
}

//保存支付平台字段映射
export const SavePayPlatformFieldMap = (params: any): any => {
    return Post('SavePayPlatformFieldMap', params)
}

//读取支付平台信息
export const GetPayPlatform = (params: any): any => {
    return Post('GetPayPlatform', params)
}
//复制支付平台
export const CopyPayPlatform = (param: object): any => {
    return Post('CopyPayPlatform', param)
}
/****end****/

/********************************************* 盘口支付管理 *******************************************/
/****start****/

// 保存盘口支付商户信息配置
export const SaveAppMchConfig = (params: any): any => {
    return Post('SaveAppMchConfig', params)
}
// 读取盘口支付商户信息列表
export const GetAppMchConfigList = (params: any): any => {
    return Post('GetAppMchConfigList', params)
}
//删除盘口支付平台配置
export const DelAppMchConfig = (param: object): any => {
    return Post('DelAppMchConfig', param)
}
//读取盘口所有支付平台
export const GetAllAppMch = (params: any): any => {
    return Post('GetAllAppMch', params)
}
//保存盘口支付通道
export const SaveAppChannel = (params: any): any => {
    return Post('SaveAppChannel', params)
}

//读取盘口支付平台所有通道
export const GetAppChannelList = (params: any): any => {
    return Post('GetAppChannelList', params)
}
//根据 支付平台id 通道码 读取所有通道
// export const GetAppChannelList = (params: any): any => {
//     return Post('GetAppChannelList', params);
// }
//删除支付通道
export const DelAppChannel = (params: any): any => {
    return Post('DelAppChannel', params)
}
//批量支付通道码
export const ChangeChannelCode = (params: any): any => {
    return Post('ChangeChannelCode', params)
}
/****end****/

/********************************************* 转入商城支付配置 *******************************************/
/****start****/

//商城页签列表
export const GetNewShopList = (params: any): any => {
    return Post('GetNewShopList', params)
}

//更新商城页签
export const UpdateNewShopInfo = (params: any): any => {
    return Post('UpdateNewShopInfo', params)
}

//商城内部配置
export const GetAppPayTypeList = (params: any): any => {
    return Post('GetAppPayTypeList', params)
}

//修改商城内部配置
export const UpdateAppPayTypeList = (params: any): any => {
    return Post('UpdateAppPayTypeList', params)
}

//请求支付用户类型配置
export const GetPayUserTypeConfig = (params: any): any => {
    return Post('GetPayUserTypeConfig', params)
}
//新增修改删除支付用户类型
export const UpdatePayUserTypeConfig = (params: any): any => {
    return Post('UpdatePayUserTypeConfig', params)
}

//支付通道配置
export const GetNewShopConfig = (params: any): any => {
    return Post('GetNewShopConfig', params)
}

//添加支付通道配置
export const AddNewShopConfig = (params: any): any => {
    return Post('AddNewShopConfig', params)
}

//修改支付通道配置
export const UpdateNewShopConfig = (params: any): any => {
    return Post('UpdateNewShopConfig', params)
}

/****end****/

/********************************************* 支付通道数据统计 *******************************************/
/****start****/

//支付订单数据列表
export const PayOrderInfo = (param: object): any => {
    return Post('PayOrderInfo', param)
}
//趋势图接口
export const PayOrderTrend = (param: object): any => {
    return Post('PayOrderTrend', param)
}
/****end****/

/********************************************* 全局代付配置 *******************************************/
/****start****/

//所有代付平台
export const GetAllProxyPayPlatform = (param: object): any => {
    return Post('GetAllProxyPayPlatform', param)
}
//保存代付平台
export const SaveProxyPayPlatform = (param: object): any => {
    return Post('SaveProxyPayPlatform', param)
}
//读取代付平台列表
export const GetProxyPayPlatformList = (param: object): any => {
    return Post('GetProxyPayPlatformList', param)
}
//删除代付平台
export const DelProxyPayPlatform = (param: object): any => {
    return Post('DelProxyPayPlatform', param)
}
//保存代付平台配置
export const SaveProxyPayPlatformConfig = (param: object): any => {
    return Post('SaveProxyPayPlatformConfig', param)
}
//保存代付平台字段映射
export const SaveProxyPayPlatformFieldMap = (param: object): any => {
    return Post('SaveProxyPayPlatformFieldMap', param)
}
//保存代付平台银行编码映射
export const SaveProxyPayPlatformBankCodeMap = (param: object): any => {
    return Post('SaveProxyPayPlatformBankCodeMap', param)
}
//读取代付平台信息
export const GetProxyPayPlatform = (param: object): any => {
    return Post('GetProxyPayPlatform', param)
}
//复制代付平台
export const CopyProxyPayPlatform = (param: object): any => {
    return Post('CopyProxyPayPlatform', param)
}
/****end****/

/********************************************* 盘口代付通道配置 *******************************************/
/****start****/

//保存盘口代付平台商户信息配置
export const SaveAppProxyMchConfig = (param: object): any => {
    return Post('SaveAppProxyMchConfig', param)
}
//读取盘口代付平台商户信息列表
export const GetAppProxyMchConfigList = (param: object): any => {
    return Post('GetAppProxyMchConfigList', param)
}
//删除盘口代付平台配置
export const DelAppProxyMchConfig = (param: object): any => {
    return Post('DelAppProxyMchConfig', param)
}
//读取盘口所有代付平台
export const GetAllAppProxyMch = (param: object): any => {
    return Post('GetAllAppProxyMch', param)
}
//保存盘口代付通道
export const SaveAppProxyChannel = (param: object): any => {
    return Post('SaveAppProxyChannel', param)
}
//读取盘口支付平台所有通道
export const GetAppProxyChannelList = (param: object): any => {
    return Post('GetAppProxyChannelList', param)
}
//删除代付通道
export const DelAppProxyChannel = (param: object): any => {
    return Post('DelAppProxyChannel', param)
}
/****end****/

/********************************************* 支付订单查询 *******************************************/
/****start****/

//新支付子商户

export const GetNewAppPayChannel = (param: object): any => {
    return Post('GetNewAppPayChannel', param)
}
//新支付类型
export const GetNewAllPayListCfg = (param: object): any => {
    return Post('GetNewAllPayListCfg', param)
}
//所有转入列表
export const GetAllPayList = (param: object): any => {
    return Post('GetAllPayList', param)
}
//读取盘口所有代付平台
export const GetAllPaySummary = (param: object): any => {
    return Post('GetAllPaySummary', param)
}

/****end****/
